module.exports = __webpack_public_path__ + "static/media/oakland.e9bd92a5.svg";